import React from "react"
import { Container } from "reactstrap"
import { useTranslation, Trans } from "react-i18next"

const RecevoirResultats = () => {
  const { t } = useTranslation()

  return (
    <div className="bg-white py-5 ">
      <Container style={{ maxWidth: "800px" }}>
        <h2 className="text-center mb-4 dark-blue pb-3">{t("recevoirresult|Quand vais-je recevoir mes résultats ?")}</h2>

        <p>
          <Trans i18nKey="Intro" ns="recevoirresult" components={{ strong: <strong /> }}/>
        </p>

        <h5 className="mt-4 mb-2 dark-blue">{t("recevoirresult|Pourquoi ce délai ?")}</h5>
        <p className="pl-2 text-justify-ho" >
          <Trans i18nKey="Technologie" ns="recevoirresult" components={{ strong: <strong /> }} />
        </p>
        <p className="pl-2" >{t("recevoirresult|Analyse unique")}</p>

        <h5 className="mt-4 mb-2 dark-blue">{t("recevoirresult|Et pendant ce temps ?")}</h5>
        <p className="pl-2" >{t("recevoirresult|Parcours")}</p>
        <p className="pl-2" >
          <Trans i18nKey="Accompagnement" ns="recevoirresult" components={{ strong: <strong /> }} />
        </p>

        <ul>
          <li>{t("recevoirresult|Bullet 1")}</li>
          <li>{t("recevoirresult|Bullet 2")}</li>
          <li>{t("recevoirresult|Bullet 3")}</li>
        </ul>

        <p className="mt-4">
          <Trans i18nKey="Objectif" ns="recevoirresult" components={{ strong: <strong /> }} />
        </p>
      </Container>
    </div>
  )
}

export default RecevoirResultats
